import { BaseAPIState } from '@philips-internal/oswald-ui-core';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';

interface BloodManagementDetailsCardProps {
  administrationRoute?: string;
  bloodNumber: number;
  chemotherapyStatus?: string;
  currentSpeedInfusion?: number;
  description?: string;
  despisedVolumeQty?: number;
  dilution?: string;
  doseQuantity?: number;
  emarStepScheduleNumber?: number;
  endDate?: string;
  expirationDate?: string,
  hourStatus?: string;
  information?: string;
  infusedVolumeQty?: number;
  isChemotherapy?: string;
  itemQuantity?: number;
  materialDescription?: string;
  measurementUnitCode?: string;
  observation?: string;
  onClick: (event: ClickEvent) => void;
  orderSequence: number;
  prescriptionId?: number;
  prescriptionNumber?: number;
  prescriptionPosition?: Position;
  processCode?: number;
  processNumber?: number;
  reservationDate?: string;
  reservationNumber?: number;
  routeAdministrationDescription?: string;
  scheduleDate?: string;
  stageQuantity?: number;
  statusDate?: string;
  statusItem?: string;
  statusItemDescription?: string;
  totalVolume?: number;
  unitMeasurement?: number;
  volumeInStepQty?: number;
}

interface BloodManagementDetailsCardAPIState extends BaseAPIState, BloodManagementDetailsCardProps {}

export enum Position {
  RIGHT = 'RIGHT',
  LEFT = 'LEFT',
}

export enum ReservedBloodProductsStatus {
  STARTED     = 'I',
  RESTARTED   = 'R',
  PENDING     = 'N',
  INTERRUPTED = 'INT',
  TERMINATE   = 'T',
  SUSPEND     = 'S'
}

export type {
  BloodManagementDetailsCardAPIState,
  BloodManagementDetailsCardProps
};

